import { Select } from "antd";
import ApiService from "../utils/ApiService";
import React, { useEffect, useState } from "react";
import useUserStore from "../stores/store";
import { constants } from "../constant/constants";

function UserListTableHeaderComponent({ 
    openModal, 
    onChangeSearchKeyWord,
    onRestaurantChange,  
    onBranchChange,
    onChangeType,
    onChangeSortBy
}) {
    const [searchKeyWord, setSearchKeyWord] = useState("");
    const [restaurantList, setRestaurantList] = useState([]);
    const [selectedRestaurantId, setSelectedRestaurantId] = useState("");
    const [branchList, setBranchList] = useState([]);
    const [selectedBranchId, setSelectedBranchId] = useState();
    const [type, setType] = useState("");

    const typeList = [
        {
            value: 1,
            label: constants.USER_TYPE.ADMIN
        },
        {
            value: 2,
            label: constants.USER_TYPE.STAFF
        },
        {
            value: 3,
            label: constants.USER_TYPE.CHEF
        }
    ];

    const sortList = [
        {
            value: '1',
            label: constants.SORT_TYPE.A_TO_Z
        },
        {
            value: '2',
            label: constants.SORT_TYPE.Z_TO_A
        },
        {
            value: '3',
            label: constants.SORT_TYPE.NEWEST
        },
        {
            value: '4',
            label: constants.SORT_TYPE.OLDEST
        }
    ];

    const { user } = useUserStore();

    useEffect(() => {
        getRestaurantList();
    }, []);

    const getRestaurantList = async () => {
        const queryParams = { listType: "SPECIAL", page: 1, perPage: 500 };

        const res = await ApiService.RESTAURANT_LIST(queryParams, user.token.token);

        if (res.status === "ok") {
            const data = res.payload.records;

            const items = data.map((item) => ({
                value: item.id,
                label: item.name
            }));

            setRestaurantList(items);
        }
    };

    const getRestaurantBranchList = async (restaurantId) => {
        const queryParams = {
            restaurantId: restaurantId,
            searchKey: "",
            status: "",
            page: 1,
            perPage: 500
        }
        
        const res = await ApiService.GET_RESTAURANT_BRANCHES(queryParams, user.token.token);

        if (res.status === "ok") {
            const data = res.payload.records;

            const items = data.map((item) => ({
                value: item.id,
                label: item.branch
            }));

            setBranchList(items);
        }
    };

    const onChangeSetSearchKeyWord = () => {
            onChangeSearchKeyWord(searchKeyWord);
    }

    const [isRestaurantEmpty, setIsRestaurantEmpty] = useState(false);
    const onChangeSetSelectedRestaurantId = async (value) => {
        if (!value) {
            // Pass empty or undefined value to call API
            onRestaurantChange("");
            setSelectedRestaurantId("");
            onBranchChange("");
            setSelectedBranchId("");
            setIsRestaurantEmpty(true);
            setBranchList([]); // Optionally clear branch list when restaurant is cleared
            return;
        }

        await getRestaurantBranchList(value);
        onRestaurantChange(value);
        setSelectedRestaurantId(value);
        setIsRestaurantEmpty(false);
    };

    const onChangeSetSelectedBranchId = (value) => {
        if (!value) {
            // Pass empty or undefined value to call API
            onBranchChange("");
            setSelectedBranchId("");
            return;
        }

        onBranchChange(value);
        setSelectedBranchId(value);
    };

    const onChangeSetType = (value) => {
      if (!value) {
        // Pass empty or undefined value to call API
        onChangeType("");
        setType("");
        return;
      }

      const findTypeById = typeList.find((it) => it.value === value);
      onChangeType(findTypeById.label);
      setType(findTypeById.label);
    };

    const onChangeSetSelectedSort = (value) => {
        const findSortById = sortList.find(it => it.value === value);
        onChangeSortBy(findSortById.label);
    };

    return (
      <div className="w-full h-[36px] mb-[21px] flex flex-row no-wrap items-center gap-x-[20px]">
        {/* start title */}
        <div className="w-[20%] h-full content-center text-left font-bold text-[24px] leading-[24px] tracking-[0px] text-[#111111] font-ubold">
          All User
        </div>
        {/* end title */}

        {/* start search box */}
        <div className="w-[15%] h-full content-center bg-white border border-[#d9d9d9] rounded-[4px] opacity-100">
          <div className="w-full h-full flex flex-row flex-nowrap items-center">
            {/* start search icon */}
            <div
              onClick={onChangeSetSearchKeyWord}
              className="w-[20%] h-full content-center cursor-pointer"
            >
              <img
                className="w-[18px] h-[18px] ml-[15px]"
                src={"/images/icons/Search.svg"}
              />
            </div>
            {/* end search icon */}

            {/* start search input */}
            <div className="w-[80%] h-full content-center">
              <input
                value={searchKeyWord}
                onChange={(e) => setSearchKeyWord(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    onChangeSetSearchKeyWord();
                  }
                }}
                className="w-full h-full bg-none border-none border-none focus:outline-none px-[10px] text-left font-uregular text-[12px] leading-[17px] tracking-normal text-[#ABB0B7] opacity-100"
                placeholder="Search Keyword"
                type="text"
              />
            </div>
            {/* end search input */}
          </div>
        </div>
        {/* end search box */}

        {/* start restaurant dropdown */}
        <div className="w-[15%] h-full content-center">
          <Select
            className="w-[100%] h-[36px] font-uregular"
            onChange={onChangeSetSelectedRestaurantId}
            showSearch
            placeholder="Restaurant"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={restaurantList}
            allowClear // This is enabled to allow clearing the selection
          />
        </div>
        {/* end restaurant dropdown */}

        {/* start branch dropdown */}
        <div className="w-[15%] h-full content-center">
          <Select
            className="w-[100%] h-[36px] font-uregular"
            onChange={onChangeSetSelectedBranchId}
            showSearch
            placeholder="Branch"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={isRestaurantEmpty ? [] : branchList}
            allowClear
          />
        </div>
        {/* end branch dropdown */}

        {/* start type dropdown */}
        <div className="w-[10%] h-full content-center">
          <Select
            className="w-[100%] h-[36px] font-uregular"
            onChange={onChangeSetType}
            placeholder="Type"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={typeList}
            allowClear
          />
        </div>
        {/* end type dropdown */}

        {/* start sort by dropdown */}
        <div className="w-[15%] h-full content-center">
          <div className="flex flex-row flex-nowrap items-center justify-center font-uregular">
            <div>Sort by</div>
            <Select
              onChange={onChangeSetSelectedSort}
              variant="borderless"
              placeholder="Borderless"
              defaultValue={sortList[2]}
              options={sortList}
            />
          </div>
        </div>
        {/* end sort by dropdown */}

        {/* start add user button */}
        <div className="w-[10%] h-full content-center">
          <div
            className="w-full h-[36px] py-[5px] text-center rounded bg-[#FCBD10] text-md font-ubold cursor-pointer"
            onClick={() => openModal(true)}
          >
            Add
          </div>
        </div>
        {/* end add user button */}
      </div>
    );
}

export default UserListTableHeaderComponent;
